<div class="centered-auth-page">

    <!-- Background -->
    <div class="auth-bg-wrapper">

        <img src="assets/images/login2.jpg" class="auth-bg-blur-img">

        <img src="assets/images/login2.jpg" class="auth-bg-main-img">

        <div class="auth-bg-overlay"></div>

    </div>


    <!-- Card -->
    <div class="login-floating-card">


        <div class="auth-header">

            <a routerLink="/" class="logo">
                Weddingly Matrimony
            </a>

            <h2>
                Welcome Merchant
            </h2>

            <p class="subtitle">
                Login to manage your photography business profile.
            </p>

        </div>



        <form [formGroup]="merchantLoginForm" 
              (ngSubmit)="onSubmit()" 
              class="auth-form">


            <!-- Email -->
            <div class="form-group">

                <label>
                    Email Address
                </label>


                <div class="input-with-icon">

                    <span class="material-symbols-outlined input-icon">
                        mail
                    </span>


                    <input type="email"
                        formControlName="email"
                        class="warm-input"
                        placeholder="merchant@gmail.com">

                </div>

            </div>



            <!-- Password -->
            <div class="form-group password-group">


                <label>
                    Password
                </label>


                <div class="input-with-icon">


                    <span class="material-symbols-outlined input-icon">
                        lock
                    </span>


                    <input [type]="hidePassword?'password':'text'"
                        formControlName="password"
                        class="warm-input"
                        placeholder="••••••••">



                    <button type="button"
                        class="password-toggle"
                        (click)="togglePassword()">

                        <span class="material-symbols-outlined">
                            {{hidePassword?'visibility_off':'visibility'}}
                        </span>

                    </button>


                </div>


            </div>



            <!-- Remember + Forgot Password -->
            <div class="form-actions-row">


                <label class="remember-me-label">

                    <input type="checkbox"
                        class="custom-checkbox">

                    <span>
                        Remember me
                    </span>

                </label>



                <a href="#"
                    class="forgot-password-link"
                    (click)="$event.preventDefault(); openForgotPassword()">

                    Forgot Password?

                </a>


            </div>




            <!-- Forgot Password Box -->
            <div *ngIf="showForgotPassword"
                class="forgot-password-panel">


                <div class="forgot-password-header">


                    <h3>
                        Reset Password
                    </h3>


                    <button type="button"
                        class="forgot-password-close"
                        (click)="closeForgotPassword()">


                        <span class="material-symbols-outlined">
                            close
                        </span>


                    </button>


                </div>



                <p class="forgot-password-copy">
                    {{forgotPasswordMessage}}
                </p>




                <div [formGroup]="forgotPasswordForm"
                    class="forgot-password-form">



                    <!-- Email OTP Request -->

                    <div class="form-group"
                        *ngIf="forgotPasswordStep === 'email'">


                        <label>
                            Email Address
                        </label>


                        <div class="input-with-icon">


                            <span class="material-symbols-outlined input-icon">
                                mail
                            </span>


                            <input type="email"
                                formControlName="forgotEmail"
                                class="warm-input"
                                placeholder="merchant@gmail.com">


                        </div>


                    </div>




                    <!-- OTP + New Password -->

                    <ng-container *ngIf="forgotPasswordStep === 'otp'">


                        <div class="form-group">


                            <label>
                                OTP
                            </label>


                            <div class="input-with-icon">


                                <span class="material-symbols-outlined input-icon">
                                    pin
                                </span>


                                <input type="text"
                                    formControlName="forgotOtp"
                                    class="warm-input"
                                    placeholder="Enter OTP">


                            </div>


                        </div>




                        <div class="form-group">


                            <label>
                                New Password
                            </label>


                            <div class="input-with-icon">


                                <span class="material-symbols-outlined input-icon">
                                    lock
                                </span>


                                <input type="password"
                                    formControlName="forgotPassword"
                                    class="warm-input"
                                    placeholder="New Password">


                            </div>


                        </div>


                    </ng-container>




                    <div class="forgot-password-actions">



                        <button *ngIf="forgotPasswordStep === 'email'"
                            type="button"
                            class="gold-button submit-btn"
                            (click)="requestForgotPasswordOtp()"
                            [disabled]="forgotPasswordLoading">


                            {{forgotPasswordLoading ? 'Sending...' : 'Send OTP'}}


                        </button>





                        <button *ngIf="forgotPasswordStep === 'otp'"
                            type="button"
                            class="gold-button submit-btn"
                            (click)="resetPasswordWithOtp()"
                            [disabled]="forgotPasswordLoading">


                            {{forgotPasswordLoading ? 'Updating...' : 'Reset Password'}}


                        </button>



                    </div>


                </div>


            </div>





            <!-- Login Button -->
            <button type="submit"
                class="gold-button submit-btn">


                <span>
                    Merchant Login
                </span>


                <span class="material-symbols-outlined">
                    login
                </span>


            </button>



        </form>




        <div class="auth-footer">


            <p>
                Don't have merchant account?

                <a routerLink="/merchant/register">
                    Register Now
                </a>

            </p>


        </div>





        <div class="login-trust-badges">


            <div class="badge-item">

                <span class="check-icon">
                    ✓
                </span>

                Verified Business

            </div>



            <div class="badge-item">

                <span class="check-icon">
                    ✓
                </span>

                Secure Login

            </div>



            <div class="badge-item">

                <span class="check-icon">
                    ✓
                </span>

                Trusted Platform

            </div>


        </div>



    </div>


</div>